// extracted by mini-css-extract-plugin
module.exports = {"header":"Title_header__1kPW0","titulo":"Title_titulo__3YY4L","title":"Title_title__CPzVW"};